import { action } from 'typesafe-actions';
import { OcorrenciaTypes, Ocorrencia } from './types';

// Todos atendimentos
export const loadRequest = (protocolo: number) =>
  action(OcorrenciaTypes.LOAD_REQUEST, {
    protocolo,
  });

export const loadSuccess = (data: Ocorrencia) => action(OcorrenciaTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(OcorrenciaTypes.LOAD_FAILURE);

export const loadRequestUpdate = (
  protocolo: number,
  status?: string,
  dtFinalizacao?: string,
  codAtendente?: number,
  urgencia?: string,
  justificativa?: string
) =>
  action(OcorrenciaTypes.LOAD_REQUEST_UPDATE, {
    protocolo,
    status,
    dtFinalizacao,
    codAtendente,
    urgencia,
    justificativa,
  });

export const loadSuccessUpdate = (data: Ocorrencia) =>
  action(OcorrenciaTypes.LOAD_SUCCESS_UPDATE, { data });

export const loadFailureUpdate = () => action(OcorrenciaTypes.LOAD_FAILURE_UPDATE, {});
